import { render, staticRenderFns } from "./ListMenuItem.vue?vue&type=template&id=46587150&scoped=true"
import script from "./ListMenuItem.vue?vue&type=script&lang=js"
export * from "./ListMenuItem.vue?vue&type=script&lang=js"
import style0 from "./ListMenuItem.vue?vue&type=style&index=0&id=46587150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46587150",
  null
  
)

export default component.exports